import openhouseAPI from "../services/openhouse";

export interface InputCreateOpenHouse {
  openHouse: {
    uuid: string;
    organization_uuid: string;
    host_user_uuid: string;
    created_by_user_uuid: string;
    property_id: string;
    form_uuid: string | null;
    instructions: string;
    start_date: string;
    start_time: string;
    end_date: string;
    end_time: string;
    is_pending: boolean;
    manual_attendee_count: number;
    is_active: false;
    active_at: string | null;
  };
  tags: string[];
  propertyDetails: {
    street_address: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
}

const useEditOpenHouse = async (inputCreateOpenHouse: InputCreateOpenHouse) => {
  openhouseAPI
    .patch("/openhouse/update", inputCreateOpenHouse)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export default useEditOpenHouse;
